import React from 'react';
import CardButton from '../CardButton/CardButton';
import './LeaderboardSlide.css';
import { cosmosTrackService } from '../../../../../cosmosTracking/cosmosTrackService';
import {view_leaderboard} from '../../../../../cosmosTracking/cosmosEvents';
import LeaderBoardTopInt from "../../LeaderboardInt/LeaderBoardTopInt";
import performers from '../../../../../assets/images/performer-sale-tittle-2026.png'
import holippl from '../../../../../assets/images/holi-people.png';
function LeaderboardSlide(props) {
    const { data, deepLink, rewardText } = props;
    return (
        <div className="slideCard slideCardBoard">
            <div className="cardBody">
                {/* <img src={performers} className='overlay-image' /> */}
                
                <img className="leader-board-top-img" src={performers} alt="title"/>
                <hr className='leader-board-top-img-border' />
                
                <LeaderBoardTopInt data={data}/>
                <CardButton
                    text={'View Leaderboard'}
                    deeplink={deepLink}
                    className={'btn-action'}
                    eventCallback={() => {
                        cosmosTrackService(view_leaderboard);
                    }}/>
            </div>
        </div>
    );
}

export default LeaderboardSlide;
